// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPublicOrderDto
 */
export interface IPublicOrderDto {
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    image_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    research_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    instrument_status?: IPublicOrderDtoInstrumentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    fund_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    type?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPublicOrderDto
     */
    date_time?: Date;
    /**
     * 
     * @type {number}
     * @memberof IPublicOrderDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IPublicOrderDto
     */
    shares?: number;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    status?: IPublicOrderDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IPublicOrderDto
     */
    side?: IPublicOrderDtoSideEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPublicOrderDto
     */
    full_liquidation?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPublicOrderDtoInstrumentStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CLOSE_ONLY = 'CLOSE_ONLY',
    HALTED = 'HALTED'
}
/**
* @export
* @enum {string}
*/
export enum IPublicOrderDtoStatusEnum {
    FILLED = 'FILLED',
    PARTIAL_FILL = 'PARTIAL_FILL',
    REJECTED = 'REJECTED',
    CANCELED = 'CANCELED',
    NEW = 'NEW',
    PENDING_CANCEL = 'PENDING_CANCEL',
    EXPIRED = 'EXPIRED',
    WAITING_APPROVAL = 'WAITING_APPROVAL',
    PAID = 'PAID'
}
/**
* @export
* @enum {string}
*/
export enum IPublicOrderDtoSideEnum {
    BUY = 'BUY',
    SELL = 'SELL'
}


/**
 * Check if a given object implements the IPublicOrderDto interface.
 */
export function instanceOfIPublicOrderDto(value: object): value is IPublicOrderDto {
    return true;
}

export function IPublicOrderDtoFromJSON(json: any): IPublicOrderDto {
    return IPublicOrderDtoFromJSONTyped(json, false);
}

export function IPublicOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPublicOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
        'image_url': json['image_url'] == null ? undefined : json['image_url'],
        'research_url': json['research_url'] == null ? undefined : json['research_url'],
        'instrument_status': json['instrument_status'] == null ? undefined : json['instrument_status'],
        'fund_name': json['fund_name'] == null ? undefined : json['fund_name'],
        'type': json['type'] == null ? undefined : json['type'],
        'date_time': json['date_time'] == null ? undefined : (new Date(json['date_time'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'shares': json['shares'] == null ? undefined : json['shares'],
        'status': json['status'] == null ? undefined : json['status'],
        'side': json['side'] == null ? undefined : json['side'],
        'full_liquidation': json['full_liquidation'] == null ? undefined : json['full_liquidation'],
    };
}

export function IPublicOrderDtoToJSON(json: any): IPublicOrderDto {
    return IPublicOrderDtoToJSONTyped(json, false);
}

export function IPublicOrderDtoToJSONTyped(value?: IPublicOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'symbol': value['symbol'],
        'image_url': value['image_url'],
        'research_url': value['research_url'],
        'instrument_status': value['instrument_status'],
        'fund_name': value['fund_name'],
        'type': value['type'],
        'date_time': value['date_time'] == null ? undefined : ((value['date_time']).toISOString()),
        'amount': value['amount'],
        'shares': value['shares'],
        'status': value['status'],
        'side': value['side'],
        'full_liquidation': value['full_liquidation'],
    };
}

